export default __webpack_public_path__ + "static/media/cupcake-4.f85b41f1.jpg";